import { render, staticRenderFns } from "./CreateIndex.vue?vue&type=template&id=4c80e585&scoped=true&"
import script from "./CreateIndex.vue?vue&type=script&lang=js&"
export * from "./CreateIndex.vue?vue&type=script&lang=js&"
import style0 from "./CreateIndex.vue?vue&type=style&index=0&id=4c80e585&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80e585",
  null
  
)

export default component.exports